<template>
	<div id="switching">
		<index>
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>办公</el-breadcrumb-item>
				<el-breadcrumb-item><a style="color: #000000;">我的代课</a></el-breadcrumb-item>
			</el-breadcrumb>
			<div class="content">
				<div class="title u-f-item u-f-jsb">
					<div>
						共{{total}}条数据
					</div>
				</div>
				<el-table :data="list" height="84%" ref="multipleTable" tooltip-effect="dark" style="width: 100%;border: 1px solid #EEEEEE;">
					<el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
					<el-table-column prop="teacher_name" label="调课老师" align="center"></el-table-column>
					<el-table-column label="调课时间" align="center">
						<template slot-scope="scope">
							<div>{{scope.row.attend_day}}{{scope.row.node}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="class_name" label="调课班级" align="center"></el-table-column>
					<el-table-column prop="discipline_name" label="调课学科" align="center"></el-table-column>
					<el-table-column prop="group.teacher_name" label="代课老师" align="center"></el-table-column>
					<el-table-column label="代课时间" align="center">
						<template slot-scope="scope">
							<div>{{scope.row.group.attend_day}}{{scope.row.group.node}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="group.class_name" label="代课班级" align="center"></el-table-column>
					<el-table-column prop="group.discipline_name" label="代课学科" align="center"></el-table-column>
					<el-table-column label="课时" align="center">
						<template slot-scope="scope">
							<div>1</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="u-f-right" style="padding: 15px 0;">
					<!-- <el-button type="danger" plain size="mini">删除</el-button> -->
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page.sync="page"
						:page-size="limit"
						layout="total, prev, pager, next"
						:total="total"
					></el-pagination>
				</div>
			</div>
		</index>
	</div>
</template>

<script>
import index from '@/components/common/index.vue';
export default {
	components: {
		index
	},
	data() {
		return {
			list:[],
			total: 0,
			page: 1,
			limit: 13
		};
	},
	mounted() {
		this.getList()
	},
	methods: {
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getList()
		},
		getList(){
			this.$api.rule.getCourseConfigList({
				page:this.page,
				limit:this.limit,
				filter:JSON.stringify({'mold':2})
			}).then(res=>{
				if(res.data.code==1){
					this.list = res.data.data.rows;
					this.total = res.data.data.total;
				}
			})
		}
	}
};
</script>

<style lang="scss">
#switching {
	.head {
		background-color: #ffffff;
		padding: 10px 30px;
		margin-top: 15px;
		.span {
			margin-right: 10px;
			background-color: #f9f9f9;
			color: #8d9da6;
			padding: 3px 10px;
		}
	}
	.content {
		background-color: #ffffff;
		height: 85vh;
		margin-top: 20px;
		padding: 0 30px;
		.title {
			padding: 15px 0;
		}
	}
	
	.el-table th > .cell,
	.el-table .cell {
		overflow: hidden; /*超出部分隐藏*/
		white-space: nowrap; /*不换行*/
		text-overflow: ellipsis; /*超出部分文字以...显示*/
	}
	.el-table thead {
		background: #fafafa !important;
	}
	.el-table th {
		padding: 15px 5px !important;
		background: #fafafa !important;
	}
	.el-table::before {
		left: 0;
		bottom: 0;
		width: 100%;
		height: 0;
	}
	
	.el-dialog__header {
		border-bottom: 1px solid #eeeeee;
		padding: 10px 20px;
		.el-dialog__title {
			font-size: 16px;
		}
	}
	.el-dialog__body {
		padding: 0 20px 35px 20px;
		.edit-box {
			.input-box {
				margin-top: 35px;
				padding-left: 15px;
				.input-lebal {
					width: 20%;
					text-align: right;
					color: #aeb5b8;
					margin-right: 10px;
					span {
						color: #ff7a65;
						margin-right: 3px;
					}
				}
				.el-icon-remove-outline {
					font-size: 1.5625vw;
					color: #d7d9db;
					margin-left: 10px;
				}
			}
			.avatar-uploader .el-upload {
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				cursor: pointer;
				position: relative;
				overflow: hidden;
			}
			.avatar-uploader .el-upload:hover {
				border-color: #409eff;
			}
			.avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				width: 90px;
				height: 90px;
				line-height: 90px;
				text-align: center;
			}
			.avatar {
				width: 90px;
				height: 90px;
				display: block;
			}
		}
	}
	.el-dialog__footer {
		padding: 15px 20px 15px;
		box-shadow: 0px -5px 10px -5px #eeeeee;
	}
}
</style>
